'use client';

import { styled } from '@linaria/react';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import Link from 'next/link';
import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';

const Title = styled.h3`
  flex: 1;
  margin-left: 4px;
  margin-right: 5px;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    -webkit-line-clamp: 2;
  }

  a {
    color: #383838;
    text-decoration: none;
    font-size: 24px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.5px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

type PopTopicTitleServerProps = {
  title: string;
  id: string;
};

const PopTopicCardTitle = ({ title, id }: PopTopicTitleServerProps) => {
  const onClickTitle = () => {
    const gtmEvent = {
      [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_POP,
      [GTMEventKey.SECTION]: 'News_Category_我的追蹤',
      [GTMEventKey.CLICK_ITEM]: `追蹤的時事＿熱門排行＿${title}`
    };
    sendGTM(gtmEvent);
  };

  return (
    <Title>
      <Link href={`/poptopic/${id}`} onClick={onClickTitle}>
        {title}
      </Link>
    </Title>
  );
};

export default PopTopicCardTitle;
